module.exports = __webpack_public_path__ + "static/media/Ios3.58138491.png";